import { AdapterFactory, withValidation } from '@bingads-webui-react/validation';
import { CronFrequencyEditor } from './cron-frequency-editor';

const CronFrequencyEditorValidationAdapter = AdapterFactory({
  valueToInject: 'cron',
});

export const CronFrequencyEditorWithValidation = withValidation(
  CronFrequencyEditor,
  CronFrequencyEditorValidationAdapter
);
